import { useTranslation } from '@mint-lib/i18n';
import { ChartColumn } from '@mint-lib/icons';
import { Card, typographyVariants } from '@mint-lib/tw-components';
import { cn } from '@mint-lib/tw-utils';

type Props = {
  errorStatus?: number;
};

const ErrorLoadingChart = ({ errorStatus }: Props) => {
  const { t } = useTranslation('@mint-lib/ai-chat');

  return (
    <Card
      color="error"
      className="mx-4 mb-2 flex flex-col self-center px-3 py-4"
    >
      <div className="flex flex-col items-center gap-2">
        <ChartColumn className="fill-error-main" />
        <div className="flex flex-col items-center gap-1">
          <p
            className={cn(
              typographyVariants({
                variant: 'bodyShort01',
              }),
              'font-bold',
            )}
          >
            {t("We can't display your chart due to a technical issue.")}
          </p>
          <p
            className={typographyVariants({
              variant: 'bodyLong01',
            })}
          >
            {errorStatus !== 404 && t('Please try again later')}
          </p>
        </div>
      </div>
    </Card>
  );
};

export default ErrorLoadingChart;
